export enum PaymentConfiguration {
    NoPayments = 0,
    YearlyPayments = 1
}